import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "notifications" };
const _hoisted_2 = { class: "notifications__title" };
const _hoisted_3 = { class: "notifications__info" };
import { ref } from 'vue';
import config from '../services/ConfigRepository';
import env from '../services/AppEnv';
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import AppForm from "@astina/paloma-common-ui/src/components/form/AppForm.vue";
import CurrentlyUnavailable from "../components/CurrentlyUnavailable.vue";
import alerts from '@astina/paloma-common-ui/src/services/Alerts';
import trans from '@astina/paloma-common-ui/src/services/Translator';
import validationUtils from '@astina/paloma-common-ui/src/services/ValidationUtils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'NotificationConfigView',
    setup(__props) {
        const form = ref(null);
        const validation = ref({ errors: [], fields: {} });
        const settings = ref(null);
        const loading = ref(false);
        const error = ref(false);
        const user = env.user;
        loadForm();
        function loadForm() {
            config.getNotificationSettingsForm()
                .then(f => {
                form.value = f.form;
                settings.value = f.data;
            })
                .catch(() => error.value = true);
        }
        function save() {
            loading.value = true;
            config.saveNotificationSettings(settings.value)
                .then(data => settings.value = data)
                .then(() => alerts.success(trans('customer_notifications_settings.save.success')))
                .catch((error) => {
                const validationLocal = validationUtils.createValidation(error);
                if (validationLocal === error) {
                    alerts.error(trans('customer_notifications_settings.save.error'));
                }
                else {
                    validation.value = validationLocal;
                }
            })
                .finally(() => loading.value = false);
        }
        function reset() {
            validation.value = { errors: [], fields: {} };
            loadForm();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('nav.config_notifications')), 1),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('customer_notifications_settings.info', { 'user_email_address': _unref(user).emailAddress })), 1),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createVNode(Spinner, {
                    loading: !form.value && !error.value
                }, null, 8, ["loading"]),
                _cache[2] || (_cache[2] = _createTextVNode()),
                (error.value)
                    ? (_openBlock(), _createBlock(CurrentlyUnavailable, { key: 0 }))
                    : _createCommentVNode("", true),
                _cache[3] || (_cache[3] = _createTextVNode()),
                (form.value)
                    ? (_openBlock(), _createBlock(AppForm, {
                        key: 1,
                        form: form.value,
                        data: settings.value,
                        validation: validation.value,
                        "submit-icon": "save",
                        "submit-label": _ctx.$t('save'),
                        "cancel-label": _ctx.$t('reset'),
                        loading: loading.value,
                        onSubmit: save,
                        onCancel: reset
                    }, null, 8, ["form", "data", "validation", "submit-label", "cancel-label", "loading"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
